// color.js

import { purple } from "@mui/material/colors";

const Colors = {
    // Primary colors
    primary: "#3498db",     // Blue
    primaryLight: "#5dade2",
    primaryDark: "#2e86c1",

    // Secondary colors
    secondary: "#e74c3c",   // Red
    secondaryLight: "#ec7063",
    secondaryDark: "#c0392b",

    // Neutral colors
    white: "#ffffff",
    white1: '#FCFFFA',
    black: "#000000",
    black1: '#0C1101',
    black2: '#151A12',
    lightGray: "#dcdcdc",
    mediumGray: "#a9a9a9",
    darkGray: "#696969",

    // Additional colors
    success: "#2ecc71",     // Green
    warning: "#f39c12",     // Yellow
    danger: "#e74c3c",      // Red (same as secondary, but you can adjust if needed)
    info: "#3498db",        // Blue (same as primary, but you can adjust if needed)

    // Backgrounds
    background: "#D3FFFA",  // Light background
    backgroundDark: "#1c2833",

    //green
    green: '#5CC2B2',
    lightGreen: '#B9FF00',

    //Purple
    purple_1: "#B983FF",


    // Text colors
    textPrimary: "#FFAA00",
    textSecondary: "#999999",
    textLight: "#f4f4f4",
    textGray: 'rgba(255, 255, 255, 0.75)',

    red: '#FF3300',
    red1: '#FF0000',

    yellow: '#FFEE00',
    darkYellow: '#FFCC00',

    // Transparent colors
    transparent: "transparent",
    overlay: "rgba(0, 0, 0, 0.5)",

    seperatorColor: '#1860B4',


    //linear gradient color
    linearGradient1: '#181A18',
    linearGradient2: '#0C0D0C',

    //

};

export default Colors;
